import * as React from 'react';

function SvgBoard(props) {
  return (
    <svg viewBox="0 0 18 15" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M3.2 5.15c1.217 0 2.168 1 2.245 2.208l.005.159v7.033H.8V7.517c0-1.225.9-2.276 2.093-2.361l.157-.006h.15zM9 .65c1.244 0 2.17 1.064 2.245 2.314l.005.164V14.55h-4.5V3.128C6.75 1.808 7.702.65 9 .65zm5.8 7.5c1.23 0 2.169 1.03 2.245 2.256l.005.161v3.983h-4.5v-3.983c0-1.296.967-2.417 2.25-2.417zM3.2 6.35h-.15c-.539 0-.987.457-1.044 1.04L2 7.517v5.833h2.25V7.517c0-.6-.412-1.096-.936-1.16L3.2 6.35zM9 1.85c-.539 0-.987.5-1.044 1.14l-.006.138V13.35h2.1V3.128c0-.703-.472-1.278-1.05-1.278zm5.8 7.5c-.539 0-.987.477-1.044 1.085l-.006.132v2.783h2.1v-2.783c0-.67-.472-1.217-1.05-1.217z" />
    </svg>
  );
}

export default SvgBoard;
